


















declare var window: any;
import { Vue, Component } from 'vue-property-decorator';
import HomeHeader from '@/components/Home/Header.vue';
import HomeCards from '@/components/Home/Cards.vue';
import ForumContentPlaceholder from '@/components/Home/ForumContentPlaceholder.vue';
import EssiumIntegrationCard from '@/components/EssiumIntegration/OnBoardingHomeCard.vue';
import HomeStaticContent from '@/components/Home/HomeStaticContent.vue';
import HomeStaticContentWithBanner from '@/components/Home/HomeStaticContentWithBanner.vue';
import CommunityForum from '@/components/Home/CommunityForum.vue';
import { vxm } from '@/store.vuex';
import { UserJobListRequest } from '@/models/jobs/userjoblistrequest';
@Component({
  components: {
    HomeHeader,
    HomeCards,
    ForumContentPlaceholder,
    HomeStaticContent,
    HomeStaticContentWithBanner,
    CommunityForum,
    EssiumIntegrationCard,
  },
})
export default class Home extends Vue {
  public userHiredStatus = false;
  mounted() {
    if (
      vxm.configs.getGlobalConfigValue('SKIP_GSU_ON_REGISTRATION_FOR_USERS_ONFILE') &&
      vxm.jobs.SkipGuidedSignUpOnRegistration
    ) {
      vxm.jobs.setSkipGuidedSignUpOnRegistration(false);
    }
    this.isUserHired().then(res => {
      if (res)this.userHiredStatus = res
    })
  }
  get isForumComingSoonEnabled() {
    return vxm.configs.subSectionEnabledInHomePage(
      'FORUM_BANNER',
      'ENABLE_FORUM_COMING_SOON',
    );
  }
  get hasHomeContent() {
    return vxm.configs.subSectionEnabledInHomePage(
      'FORUM_IMAGE_PLACE_HOLDER',
      'HOME_CONTENT',
    );
  }
  get isEssiumIntegrationEnabled() {
    return vxm.configs.subSectionEnabledInHomePage(
      'ONBOARDING',
      'ENABLE_ESSIUM_INTEGRATION',
    ) && this.userHiredStatus;
  }
  async isUserHired() { 
    const reqObj: UserJobListRequest = {
    sessionToken: '123',
    jobStatus: '03',
    resultSize: 1,
    resultPage: 1,
    resultCount: 0,
    };
    var isUserHiredStatus = false
    await vxm.jobs.getMyJobStatus(reqObj).then(
      (res) => {
        if (res && res.data.resultCount > 0) { 
          isUserHiredStatus = true;
        }
      }
    )
    return isUserHiredStatus;
  }
  get ishomeHeader() {
    if (window.WorkLLama.isConfigJSONEnabled === 'true') {
      const homeHeader = vxm.configs.slideMenuSubSections(
        'HOME',
        'WELCOME_TEXT',
      );
      return homeHeader ? true : false;
    }
    return true;
  }
  get showForumInHomePage() {
    if (
      vxm.configs.subSectionEnabledInHomePage(
        'FORUM',
        'SHOW_FORUM_IN_HOME_PAGE',
      )
    ) {
      if (
        vxm.configs.getGlobalConfigValue(
          'CHECK_USER_PROFILE_FORUM_ENABLED_FLAG',
        )
      ) {
        return vxm.users.myUserProfile.enableForum;
      } else {
        return true;
      }
    } else {
      return false;
    }
  }
}
